import React from 'react';
import DatePicker from 'react-datepicker';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Form, Dropdown } from 'semantic-ui-react';

import HashtagsInput from '../../components/hashtags-input';
import { DYZIO_CURRENCIES, CURRENCY_GBP } from '../../utils/helpers/currencies';
import { transformHashtagstIntoArray } from '../../utils/hashtags-utils';

const currencyDropDownStyle = { marginTop: 8, marginBottom: 8 };
const requiredLabelStyle = { color: 'red' };
const RequiredLabel = () => (<span style={requiredLabelStyle}>*</span>);
const isACR = type => type === 'ACR';

const CampaignForm = props => {
  const {
    name,
    budget,
    campaignType,
    liveDate,
    hashtags,
    currency,
    endDate,
    onInputChange,
    onFormSubmit,
    onCurrencyChange,
    onLiveDateChange,
    onEndDateChange,
  } = props;
  return (
    <Form onSubmit={onFormSubmit}>

      <Form.Field>
        <label htmlFor="campaign-name">Campaign name<RequiredLabel /></label>
        <Form.Input
          onChange={onInputChange}
          placeholder="e.g. Sky Westworld"
          name="name"
          value={name}
        />
      </Form.Field>

      {
        !isACR(campaignType) &&
        <div>
          <Form.Field>
            <label htmlFor="campaign-currencies">Currency</label>
            <Dropdown
              fluid
              search
              style={currencyDropDownStyle}
              onChange={onCurrencyChange}
              value={currency || CURRENCY_GBP}
              name="currency"
              options={DYZIO_CURRENCIES}
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor="campaign-budget">Total Budget<RequiredLabel /></label>
            <Form.Input
              type="number"
              onChange={onInputChange}
              placeholder="e.g. £10,000"
              name="budget"
              value={budget}
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor="campaign-live-date">Live Date</label>
            <DatePicker
              onChange={onLiveDateChange}
              placeholderText="e.g. 01/05/2018"
              selected={liveDate && liveDate.isValid() ? liveDate.utc() : null}
              dateFormat="MMM Do YYYY"
            />
          </Form.Field>

          <Form.Field>
            <label htmlFor="campaign-end-date">End Date</label>
            <DatePicker
              onChange={onEndDateChange}
              placeholderText="e.g. 20/05/2018"
              selected={endDate && endDate.isValid() ? endDate.utc() : null}
              dateFormat="MMM Do YYYY"
            />
          </Form.Field>

          <HashtagsInput
            hashtags={transformHashtagstIntoArray(hashtags)}
            onValueChanged={onInputChange}
          />
        </div>
      }

    </Form>
  );
};

CampaignForm.propTypes = {
  name: PropTypes.string,
  budget: PropTypes.number,
  liveDate: PropTypes.object,
  hashtags: PropTypes.string,
  currency: PropTypes.string,
  endDate: PropTypes.object,
  onInputChange: PropTypes.func.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  onLiveDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
};


export default CampaignForm;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-form/index.js
 **/